<!-- <p>classification works!</p> -->
<!-- <ng-select placeholder="Primary Key for {{relobj?.['name']}}" [(ngModel)]="relobj['primary_key']">
    <ng-option *ngFor="let item of pkarr" [value]="item">{{item}}</ng-option>
  </ng-select> -->
<div class="list-card">
  <div class="list-container">
    <div class="heading">

      <h3 class="list-heading"><i class="fa fa-file heading-icon"></i>Classification</h3>
    </div>
    <div class="button-container">
      <ng-select placeholder="Select Term" [(ngModel)]="selectedTermId" [items]="termarr" class="termselect" (change)="inputchange()"  [bindLabel]="'di_bus_nm'">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item?.di_tech_nm}}">
            {{item?.di_bus_nm}}
          </div>
        </ng-template>
      </ng-select>
      
      


      <button mat-raised-button class="button-right add-button" *ngIf="listflag" (click)="onAddButtonClick()">
        <i class="fa fa-plus"></i> Add
      </button>
      <button mat-raised-button class="button-right add-button" *ngIf="addflag || updateflag || viewflag"
        (click)="gotolist()">
        <i class="fa fa-plus"></i> List
      </button>
    </div>
    <div *ngIf="listflag">
      <lib-list [config]="CL" (onViewItemEvent)="onViewClicked($event)" (onUpdateItemEvent)="onUpdateClicked($event)">
      </lib-list>
    </div>
    <div *ngIf="addflag || viewflag || updateflag">

      <div *ngIf="selectedTermId?.di_tcd_json?.cl_type?.['av_tcd']=='SV'">
        <mat-card class="example-card1">
          <div class="row-container">
            <div class="left-content"></div>
            <mat-icon class="right-content" style="color:rgb(0, 140, 255)" (click)="onAddClassification()"
              *ngIf="addflag">
              add_box
            </mat-icon>
          </div>

          <table class="table table-bordered" style="width: 90%; margin-left: 5%;">
            <thead>
              <tr class="Table-header">
                <td>Code</td>
                <td>Value</td>
                <td *ngIf="addflag">Action</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let classification of clarr; let j = index">
                <td>
                  <mat-form-field>
                    <mat-label>Classification Code</mat-label>
                    <input matInput type="text" class="example-right-align" placeholder=""
                      [(ngModel)]="classification.cl_cd" [ngModelOptions]="{standalone: true}" width="100%">
                    <!-- <mat-icon class="icon" matSuffix>edit</mat-icon> -->
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field>
                    <mat-label>Classification Value</mat-label>
                    <input matInput type="text" class="example-right-align" placeholder=""
                      [(ngModel)]="classification.cl_val" [ngModelOptions]="{standalone: true}">
                    <!-- <mat-icon class="icon" matSuffix>edit</mat-icon> -->
                  </mat-form-field>
                </td>
                <td *ngIf="addflag">
                  <mat-icon style="color:red" (click)="onDeleteClassification(j)">delete</mat-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </mat-card>
      </div>
      <div *ngIf="selectedTermId?.di_tcd_json?.cl_type?.['av_tcd']=='MV'">
        <div class="form-container">
          <br>
          <mat-form-field class="field1">
            <mat-label>Classification Code</mat-label>
            <input matInput type="text" class="example-right-align" placeholder="" [(ngModel)]="classificationCode"
              [ngModelOptions]="{standalone: true}" required>
            <mat-error *ngIf="!classificationCode">Classification Code is required</mat-error>
          </mat-form-field>

          <mat-label>
            <h3 class="list-heading"><i class="fa fa-file heading-icon"></i>Classification Value</h3>
          </mat-label>
          <form [formGroup]="form" *ngIf="fields" class="form-body">
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>

          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12 button-container">
          <button mat-button color="primary" (click)="submit()" *ngIf="addflag">Submit</button>
          <button mat-button color="primary" (click)="update()" *ngIf="updateflag">Update</button>
        </div>
      </div>




    </div>

  </div>

</div>
